import useRuntimeConfig from '@vl-core/hooks/useConfig';

export {useRuntimeConfig};
export default useRuntimeConfig;
